<template>
    <div class="container mb-3 mt-3 card-body">

        <h3 class="mb-4 text-primary font-weight-bold"><i class="fa fa-mountain" aria-hidden="true"></i>
            เพิ่มภาพพื้นหลัง
        </h3>

        <div class="form-group" v-if="bgImage">
            <img class="img-fluid"
                    :src="bgImage"
            >
        </div>

        <div class="form-group">
            <div class="custom-file">
                <input type="file" class="custom-file-input" @change="previewImage($event)" accept="image/*">
                <label class="custom-file-label">Choose file</label>
            </div>
            <error-message class="mt-2" :msg="errorMessage.img"></error-message>
        </div>

        <div>
            <base-button type="secondary" @click="close">
                ยกเลิก
            </base-button>

            <base-button type="primary" @click="save">
                ยืนยันข้อมูล
            </base-button>
        </div>


    </div>

</template>
<script>

    import validate from 'validate.js';
    import store from '../store';
    import {mapState} from 'vuex';
    import {
        ADD_BACKGROUND
    } from "../store/actions.type";
    import Swal from 'sweetalert2/src/sweetalert2.js'
    import ErrorMessage from "./ErrorMessage";


    export default {
        name: 'addbg',
        components: {ErrorMessage},
        computed: {
            ...mapState({}),
        },
        props: {
            data: Object
        },
        data() {
            return {
                file: null,
                bgImage: "",
                errorMessage: {},
                isLoading: false,
            }
        },

        methods: {
            close() {
                this.$emit("closePanel", {});
            },

            async save() {
                let errorMessage = this.validateForm(this.file);

                if (errorMessage) {
                    return this.errorMessage = errorMessage;
                } else {
                    this.errorMessage = {};
                }

                if (this.isLoading) return;
                this.isLoading = true;

                await store.dispatch(ADD_BACKGROUND, this.file);

                Swal.fire(
                    {
                        text: `บันทึกข้อมูลสำเร็จ`,
                        type: 'success',
                        customClass: {
                            confirmButton: 'btn-primary'
                        }
                    });


                this.isLoading = false;

                // close dialog
                this.$emit("closePanel", {confirm: true});
            },


            previewImage: function (event) {
                let input = event.target;
                // Ensure that you have a file before attempting to read it
                if (input.files && input.files[0]) {
                    this.file = input.files[0];

                    // create a new FileReader to read this image and convert to base64 format
                    let reader = new FileReader();
                    // Define a callback function to run, when FileReader finishes its job
                    reader.onload = (e) => {
                        // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                        // Read image as base64 and set to imageData
                        this.bgImage = e.target.result;
                    };
                    // Start the reader job - read file as a data url (base64 format)
                    reader.readAsDataURL(input.files[0]);

                }
            },

            validateForm(data) {
                let validateRule = null;
                let errMessageList = null;

                validateRule = {
                    img: {
                        presence: {
                            allowEmpty: false,
                            message: "^โปรดเลือกรูปภาพ"
                        },
                    }
                };

                errMessageList = validate(
                    {
                        img: data
                    }, validateRule);

                if (errMessageList) {
                    const error = {};
                    for (const [key, value] of Object.entries(errMessageList)) {
                        error[key] = value[0];
                    }
                    return error;
                } else {
                    return false;
                }

            },
        },
    };
</script>


<style lang="scss" scoped>

</style>
